/*
 * Vuex-store.ts
 * Description: Defining global vuex object for storing data
 */

// Importing modules
import {
    moduleCurrentPage,
    moduleLastPage,
} from '@/ts/vuex/modules-page';
import {
    moduleLoading,
    moduleOrderParam,
    moduleQueryParam,
    moduleSortParam,
} from '@/ts/vuex/modules-load';

// Declaring module for server response
const moduleResponse = {
    state: {
        response: [],
    },
    mutations: {
        SET_RESPONSE(state, value) {
            state.response = value;
        },
        REMOVE_RESPONSE_ITEM(state, value) {
            state.response.splice(value);
        },
    },
    actions: {
        setResponse({commit, state}, temp) {
            commit('SET_RESPONSE', temp);
        },
        removeResponseItem({commit, state}, temp) {
            commit('REMOVE_RESPONSE_ITEM', temp);
        },
    },
    getters: {
        response(state) {
            return state.response;
        },
    },
};

export const data = {
    state: {},
    modules: {
        // Server response
        response: moduleResponse,
        // Page navigation
        current_page: moduleCurrentPage,
        last_page: moduleLastPage,
        // Loading state
        loading: moduleLoading,
        // Request parameters
        query_param: moduleQueryParam,
        sort_param: moduleSortParam,
        order_param: moduleOrderParam,
    },
    mutations: {},
    actions: {},
    getters: {},
};

